/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SortOrder } from './SortOrder';
import {
    SortOrderFromJSON,
    SortOrderFromJSONTyped,
    SortOrderToJSON,
    SortOrderToJSONTyped,
} from './SortOrder';
import type { RoleSearchOrderBy } from './RoleSearchOrderBy';
import {
    RoleSearchOrderByFromJSON,
    RoleSearchOrderByFromJSONTyped,
    RoleSearchOrderByToJSON,
    RoleSearchOrderByToJSONTyped,
} from './RoleSearchOrderBy';

/**
 * 
 * @export
 * @interface RoleSearchSortingQuery
 */
export interface RoleSearchSortingQuery {
    /**
     * 
     * @type {SortOrder}
     * @memberof RoleSearchSortingQuery
     */
    order?: SortOrder;
    /**
     * 
     * @type {RoleSearchOrderBy}
     * @memberof RoleSearchSortingQuery
     */
    orderBy?: RoleSearchOrderBy;
}



/**
 * Check if a given object implements the RoleSearchSortingQuery interface.
 */
export function instanceOfRoleSearchSortingQuery(value: object): value is RoleSearchSortingQuery {
    return true;
}

export function RoleSearchSortingQueryFromJSON(json: any): RoleSearchSortingQuery {
    return RoleSearchSortingQueryFromJSONTyped(json, false);
}

export function RoleSearchSortingQueryFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoleSearchSortingQuery {
    if (json == null) {
        return json;
    }
    return {
        
        'order': json['order'] == null ? undefined : SortOrderFromJSON(json['order']),
        'orderBy': json['orderBy'] == null ? undefined : RoleSearchOrderByFromJSON(json['orderBy']),
    };
}

export function RoleSearchSortingQueryToJSON(json: any): RoleSearchSortingQuery {
    return RoleSearchSortingQueryToJSONTyped(json, false);
}

export function RoleSearchSortingQueryToJSONTyped(value?: RoleSearchSortingQuery | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'order': SortOrderToJSON(value['order']),
        'orderBy': RoleSearchOrderByToJSON(value['orderBy']),
    };
}

